export default "__VITE_ASSET__CoHfZ$VP__"